var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"default-page standard-page"},[_c('DefaultPageHeader',{attrs:{"title":_vm.page.title,"lead":_vm.page.lead,"pages":_vm.submenuLinks}}),_vm._v(" "),_c('lazy-mount',{attrs:{"delay":800}},[_c('blocks')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }